// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"226":"2e131884092ac721","353":"bf99f76991def8e8","3238":"044745cf02d6c123","4071":"c34466a31d491cf2","6271":"69da0569ec723f33","6643":"5d3548054d2adfce","9474":"44396c2229fbc8bd"}[chunkId] + ".js";
};